(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ortkraft-collection-filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    const group = event.target;
    if (!(group instanceof HTMLDetailsElement) || !group.matches('.ort-filter-group') || !group.open) return;
    group.closest('form').querySelectorAll('.ort-filter-group[open]').forEach(other => { if (other !== group) other.open = false; });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const group = event.target.closest?.('.ort-filter-group[open]');
    if (group) { group.open = false; group.querySelector('summary').focus(); }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.ort-filter-group[open]').forEach(group => { if (!group.contains(event.target)) group.open = false; });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ortkraft-collection-sort"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ortkraft-collection-sort')) {
    customElements.define('ortkraft-collection-sort', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-enhanced')) return;
        const form = this.querySelector('form');
        const select = this.querySelector('select');
        if (!form || !select) return;
        select.addEventListener('change', () => form.requestSubmit());
        this.setAttribute('data-enhanced', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
